// extracted by mini-css-extract-plugin
export default {"skill":"About_skill__kyb2f","title":"About_title__rDDoF","container":"About_container__r9A2e"};